import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import multi from 'redux-multi'
import promise from 'redux-promise'
import { persistStore, persistReducer } from 'redux-persist'
import { composeWithDevTools } from 'redux-devtools-extension'
import { routerMiddleware } from 'connected-react-router'
import storage from 'redux-persist/lib/storage'
import {
  seamlessImmutableReconciler,
  seamlessImmutableTransformCreator
} from 'redux-persist-seamless-immutable'
import createRootReducer from './reducers'
import history from '../lib/history'

export const middlewares = [thunk, multi, promise]
const isDev = () => process.env.NODE_ENV === 'development'

export const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'alertsReducer',
    'authReducer',
    'extractReducer',
    'filtersReducer',
    'knowledgeBaseReducer',
    'timelineReducer',
    'modalReducer',
    'routerReducer',
    'searchReducer',
    'usersReducer',
    'walletReducer',
    'sessionReducer',
    'meReducer',
    'profileReducer'
  ],
  whiteList: ['menuReducer', 'currentUserReducer'],
  stateReconciler: seamlessImmutableReconciler,
  transforms: [seamlessImmutableTransformCreator({})]
}

const rootReducer = createRootReducer(history)
const persistedReducer = persistReducer(persistConfig, rootReducer)

const middlewaresApplied = applyMiddleware(
  routerMiddleware(history),
  ...middlewares
)

export default () => {
  const store = createStore(
    persistedReducer,
    compose(
      isDev ? composeWithDevTools(middlewaresApplied) : middlewaresApplied
    )
  )

  const persistor = persistStore(store)

  return { store, persistor }
}
